import { AbstractControl, ValidationErrors } from '@angular/forms';

export class customValidator {


    static validationFilters(control: AbstractControl) {
        let shipmentNumber = control.get('shipment_num');
        let dateFilter = control.get('dateFilter');
        let statusSelect = control.get('statusSelect');
        let countrySelect =control.get('countrySelect')
        if (shipmentNumber.value || dateFilter.value || statusSelect.value || countrySelect.value){
            return null;
        }
               return { pwdsDontMatch: true };
           
    }
}